import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MdLogout, MdNoteAdd, MdMenuOpen } from "react-icons/md";
import Modal from "@/features/shared/components/Modal/Modal";
import TaskForm from "@/features/task/components/taskForm/TaskForm";
import useTasks from "@/features/task/hooks/useTasks";
import { useAuth } from "@/auth/useAuth";
import { FaUserCircle } from "react-icons/fa";
import { useQuery } from "react-query";
import { fetchParameterValue } from "@/features/parameter/services/parameterService";
import { getAttachmentUrl } from "@/features/attachments/services/attachmentService";
const Header = ({ onMenuClick }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [profilePhotoUrl, setProfilePhotoUrl] = useState();
    const { handleAddTask } = useTasks();
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const menuRef = useRef(null);
    const { data: appTitle } = useQuery(["parameter", "APP_TITLE"], () => fetchParameterValue("APP_TITLE"), {
        staleTime: 5 * 60 * 1000,
    });
    useEffect(() => {
        if (!user?.profile_photo?.file_path) {
            setProfilePhotoUrl(undefined);
            return;
        }
        // Use direct URL to avoid blob: (CSP friendly)
        const url = getAttachmentUrl(user.profile_photo.file_path);
        setProfilePhotoUrl(url);
    }, [user?.profile_photo?.id]);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setIsProfileOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const handleAddTaskClick = () => setIsModalVisible(true);
    const handleCloseModal = () => setIsModalVisible(false);
    const handleSubmit = async (taskData) => {
        try {
            const createdTaskId = await handleAddTask(taskData);
            setIsModalVisible(false);
            if (createdTaskId) {
                navigate(`/tasks/${createdTaskId}`);
            }
        }
        catch (err) {
            console.error("Erreur lors de la création de tâche :", err);
        }
    };
    const handleLogout = async () => {
        try {
            await logout();
        }
        catch (err) {
            console.error("Erreur lors de la déconnexion :", err);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("header", { className: "relative z-40 flex items-center p-4 bg-white shadow-md h-16", children: [_jsx("button", { onClick: onMenuClick, className: "md:hidden mr-2 w-11 h-11 flex items-center justify-center rounded hover:bg-gray-100", "aria-label": "Ouvrir le menu", children: _jsx(MdMenuOpen, { className: "w-6 h-6" }) }), _jsx("h1", { className: "flex-1 min-w-0 text-xl font-bold text-blue-600 text-center truncate", children: _jsx(Link, { to: "/", className: "flex items-center justify-center space-x-2 text-blue-600 hover:text-blue-700", children: _jsx("img", { src: "/tadbir_logo.PNG", alt: "Logo Tadbir", className: "h-[2.35rem] md:h-[3.8rem]" }) }) }), _jsxs("div", { className: "flex items-center space-x-4", children: [_jsxs("button", { type: "button", onClick: handleAddTaskClick, className: "bg-blue-500 text-white p-2 rounded hover:bg-blue-600 flex items-center", title: "Cr\u00E9er une nouvelle t\u00E2che", children: [_jsx(MdNoteAdd, { className: "w-5 h-5 mr-1" }), _jsx("span", { children: "Cr\u00E9er" })] }), _jsxs("div", { className: "relative z-50", ref: menuRef, children: [_jsxs("button", { onClick: () => setIsProfileOpen(open => !open), className: "flex items-center space-x-2 p-2 hover:bg-gray-100 rounded", title: "Mon profil", children: [profilePhotoUrl ? (_jsx("img", { src: profilePhotoUrl, alt: "Photo de profil", className: "w-8 h-8 rounded-full object-cover border border-gray-200" })) : (_jsx(FaUserCircle, { className: "w-6 h-6 text-gray-600" })), _jsx("span", { className: "hidden md:inline text-gray-700", children: user?.first_name || user?.email })] }), isProfileOpen && (_jsxs("div", { className: "absolute right-0 mt-2 w-48 bg-white border rounded shadow-lg z-50", children: [_jsxs("div", { className: "px-4 py-3 border-b", children: [_jsxs("p", { className: "font-medium text-gray-800", children: [user?.first_name, " ", user?.last_name] }), _jsx("p", { className: "text-sm text-gray-500 truncate", children: user?.email })] }), _jsx(Link, { to: "/account", className: "block px-4 py-2 text-gray-700 hover:bg-gray-100", onClick: () => setIsProfileOpen(false), children: "Afficher mon compte" }), _jsx("button", { onClick: handleLogout, className: "w-full px-4 text-left text-gray-700 hover:bg-gray-100", title: "Se d\u00E9connecter", children: _jsxs("div", { className: "flex items-center py-2 space-x-2  text-gray-700 hover:bg-gray-100", children: [_jsx(MdLogout, { className: "w-5 h-5" }), _jsx("span", { children: "D\u00E9connexion" })] }) })] }))] })] })] }), isModalVisible && (_jsx(Modal, { onClose: handleCloseModal, children: _jsx(TaskForm, { onSubmit: handleSubmit, onCancel: handleCloseModal }) }))] }));
};
export default Header;
